import { motion } from "framer-motion";

// Reusable section heading with gold accent line
export const SectionHeading = ({ eyebrow, title, subtitle, align = "left", light = false }) => {
  const centered = align === "center";
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.5 }}
      className={`max-w-3xl ${centered ? "mx-auto text-center" : ""} mb-12`}
    >
      <div className={`h-[3px] w-14 bg-[#C89B3C] mb-5 ${centered ? "mx-auto" : ""}`} />
      {eyebrow && (
        <span
          className={`text-xs font-medium tracking-[0.2em] uppercase mb-3 block ${
            light ? "text-[#C89B3C]" : "text-slate-500"
          }`}
        >
          {eyebrow}
        </span>
      )}
      <h2
        className={`font-serif text-3xl md:text-4xl lg:text-5xl font-bold leading-tight ${
          light ? "text-white" : "text-slate-900"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`text-base md:text-lg mt-5 leading-relaxed ${
            light ? "text-slate-300" : "text-slate-600"
          }`}
        >
          {subtitle}
        </p>
      )}
    </motion.div>
  );
};

export default SectionHeading;
